// node modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

// app modules: components
import ContentOptions from 'components/ContentOptions';
import Icon from 'components/Icon';

// app modules: props
import AuthorsProps from 'components/Authors/AuthorsProps';

// app modules: constants
import { COLOURS } from 'constants/index';

class ContentOptionsAsButton extends PureComponent {
  static propTypes = {
    authors: AuthorsProps.authors,
    itemId: PropTypes.string.isRequired,
    itemType: PropTypes.string.isRequired,
  };

  static defaultProps = {
    authors: [],
  };

  render() {
    return (
      <ContentOptions {...this.props}>
        <Icon fill={COLOURS.ENERGIZED} name="dots" height="20" width="20" />
      </ContentOptions>
    );
  }
}

export default ContentOptionsAsButton;
